<template>
    <div class="agreement-home-page page-pad">
        <div>
            <div>{{ $t('redTips') }}</div>
            <div>{{ $t('thankUseApp') }}</div>
            <div>
                <div class="first-line-2">
                    {{ $t('sketchAllAgreement') }}
                </div>
                <div>
                    <router-link :to="{ name: RouterNames.InformationList }">
                        {{ $t('personalInformation') }}
                    </router-link>
                    、
                    <router-link :to="{ name: RouterNames.SdkList }">
                        {{ $t('sdkList') }}
                    </router-link>
                    、
                    <router-link :to="{ name: RouterNames.AppJurisdiction }">
                        {{ $t('appJurisdictionExplain') }}
                    </router-link>
                    {{ $t('fullStop') }}
                </div>
            </div>
        </div>

        <div>
            <h1 class="title-1">
                {{ $t('vvflvSleepPolicy') }}
            </h1>
            <div class="paragraph">
                {{ $t('vvflvSleepPolicyMessage1') }}
            </div>
            <div class="paragraph">
                {{ $t('vvflvSleepPolicyMessage2') }}
            </div>
            <div class="paragraph">
                {{ $t('vvflvSleepPolicyMessage3') }}
            </div>
            <div class="paragraph">
                {{ $t('vvflvSleepPolicyMessage4') }}
            </div>
            <div class="paragraph">
                {{ $t('vvflvSleepPolicyMessage5') }}
            </div>
            <div class="paragraph">
                {{ $t('vvflvSleepPolicyMessage6') }}
            </div>
            <div class="paragraph">
                <div>{{ $t('vvflvSleepPolicyMessage7') }}</div>
                <div>{{ $t('policy1') }}</div>
                <div>{{ $t('policy2') }}</div>
                <div>{{ $t('policy3') }}</div>
                <div>{{ $t('policy4') }}</div>
                <div>{{ $t('policy5') }}</div>
                <div>{{ $t('policy6') }}</div>
                <div>{{ $t('policy7') }}</div>
                <div>{{ $t('policy8') }}</div>
                <div>{{ $t('policy9') }}</div>
                <div>{{ $t('policy10') }}</div>
                <div>{{ $t('policy11') }}</div>
            </div>

            <div>
                <div>
                    <h2 class="title-3">{{ $t('policy1') }}</h2>
                    <div>
                        <div class="paragraph">{{ $t('policy1Message1') }}</div>
                        <div class="paragraph">{{ $t('policy1Message2') }}</div>
                    </div>
                </div>

                <div>
                    <h2 class="title-3">{{ $t('policy2') }}</h2>
                    <div>
                        <div class="paragraph">{{ $t('policy2Message1') }}</div>
                        <div class="paragraph">{{ $t('policy2Message2') }}</div>
                        <div class="paragraph">
                            <div>{{ $t('policy2Message3') }}</div>
                            <div class="paragraph-indent">
                                <div class="paragraph">
                                    {{ $t('policy2Message3_1') }}
                                </div>
                                <div class="paragraph">
                                    {{ $t('policy2Message3_2') }}
                                </div>
                                <div class="paragraph">
                                    {{ $t('policy2Message3_3') }}
                                </div>
                                <div class="paragraph">
                                    {{ $t('policy2Message3_4') }}
                                </div>
                            </div>
                        </div>
                        <div>
                            <div>{{ $t('policy2Message4') }}</div>
                            <div v-if="showLang === Lang.enUS" class="paragraph">
                                {{ $t('policy2Message4_1') }}
                            </div>
                            <div v-else class="paragraph-indent">
                                <div class="paragraph">
                                    {{ $t('policy2Message_up_4_1') }}
                                </div>
                                <div class="paragraph">
                                    {{ $t('policy2Message_up_4_2') }}
                                </div>
                                <div class="paragraph">
                                    {{ $t('policy2Message_up_4_3') }}
                                </div>
                                <div class="paragraph">
                                    {{ $t('policy2Message_up_4_4') }}
                                </div>
                            </div>
                        </div>

                        <div>
                            <div>{{ $t('policy2Message5') }}</div>
                            <div class="paragraph-indent">
                                <div class="paragraph">
                                    {{ $t('policy2Message5_1') }}
                                </div>
                                <div class="paragraph">
                                    {{ $t('policy2Message5_2') }}
                                </div>
                            </div>
                        </div>

                        <div>
                            <div>{{ $t('policy2Message6') }}</div>
                            <div class="paragraph-indent">
                                <div class="paragraph">
                                    {{ $t('policy2Message6_1') }}
                                </div>
                                <div class="paragraph">
                                    {{ $t('policy2Message6_2') }}
                                </div>
                                <div class="paragraph">
                                    {{ $t('policy2Message6_3') }}
                                </div>
                                <div class="paragraph">
                                    {{ $t('policy2Message6_4') }}
                                </div>
                                <div class="paragraph">
                                    {{ $t('policy2Message6_5') }}
                                </div>
                                <div class="paragraph">
                                    <div>
                                        {{ $t('policy2Message6_6') }}
                                    </div>
                                    <div>
                                        <div>{{ $t('policy2Message6_6_1') }}</div>
                                        <div>{{ $t('policy2Message6_6_2') }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-if="showLang === Lang.zhCN" class="paragraph">
                            <div class="thick-txt">
                                {{ $t('policy2Message7') }}
                            </div>
                            <div class="paragraph-indent">
                                <div>
                                    <div>{{ $t('policy2Message7_1') }}</div>
                                    <div>{{ $t('policy2Message7_1_1') }}</div>
                                </div>
                                <div>
                                    <div>{{ $t('policy2Message7_2') }}</div>
                                    <div>{{ $t('policy2Message7_2_1') }}</div>
                                </div>
                            </div>

                            <div class="">
                                <div>8.自启动和关联启动说明</div>
                                <div class="paragraph-indent">
                                    <div>
                                        1）为确保本应用处于关闭或后台运行状态下可正常接收到客户端推送的信息，本应用须
                                        使用(自启动)能力，将存在一定频率通过系统发送广播唤醒本应用自启动或关联启动行
                                        为,是因实现功能及服务所必要的
                                    </div>
                                    <div>
                                        2）当您打开内容类推送消息，在征得您的明确同意后，会跳转打开相关内容。在未征得
                                        您同意的情况下，则不会有自启动或关联启动。
                                    </div>
                                    <div>
                                        3）当您打开本App内部下载的文件后，会关联启动第三方App。
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div>
                    <h2 class="title-3">{{ $t('policy3') }}</h2>
                    <div>
                        <div class="paragraph">{{ $t('policy3Message1') }}</div>
                        <div class="paragraph">{{ $t('policy3Message2') }}</div>
                        <div class="paragraph">{{ $t('policy3Message3') }}</div>
                        <div class="paragraph">{{ $t('policy3Message4') }}</div>
                        <div v-if="showLang === Lang.zhCN">
                            <div class="paragraph">{{ $t('policy3Message5') }}</div>
                            <div class="paragraph thick-txt">
                                {{ $t('policy3Message5_2') }}
                            </div>
                            <div class="paragraph thick-txt">{{ $t('policy3Message6') }}</div>
                        </div>
                    </div>
                </div>

                <div>
                    <h2 class="title-3">{{ $t('policy4') }}</h2>
                    <div>
                        <div class="paragraph">{{ $t('policy4Message0') }}</div>
                        <div class="paragraph">{{ $t('policy4Message1') }}</div>
                        <div class="paragraph">{{ $t('policy4Message2') }}</div>
                        <div class="paragraph">{{ $t('policy4Message3') }}</div>
                        <div class="paragraph">{{ $t('policy4Message4') }}</div>
                        <div class="paragraph">{{ $t('policy4Message5') }}</div>
                        <div class="paragraph">{{ $t('policy4Message6') }}</div>
                    </div>
                </div>

                <div>
                    <h2 class="title-3">{{ $t('policy5') }}</h2>
                    <div>
                        <div class="paragraph">{{ $t('policy5Message1') }}</div>
                        <div class="paragraph">{{ $t('policy5Message2') }}</div>
                        <div class="paragraph">{{ $t('policy5Message3') }}</div>
                        <div class="paragraph">{{ $t('policy5Message4') }}</div>
                        <div class="paragraph">{{ $t('policy5Message5') }}</div>
                        <div class="paragraph">{{ $t('policy5Message6') }}</div>
                    </div>
                </div>

                <div>
                    <h2 class="title-3">{{ $t('policy6') }}</h2>
                    <div>
                        <div class="paragraph">{{ $t('policy6Message0') }}</div>
                        <div class="paragraph">{{ $t('policy6Message1') }}</div>
                        <div class="paragraph">{{ $t('policy6Message2') }}</div>
                    </div>
                </div>

                <div>
                    <h2 class="title-3">{{ $t('policy7') }}</h2>
                    <div>
                        <div class="paragraph">{{ $t('policy7Message1_1') }}</div>
                        <div class="paragraph">{{ $t('policy7Message2_1') }}</div>
                        <div class="paragraph">{{ $t('policy7Message3_1') }}</div>
                        <div class="paragraph">{{ $t('policy7Message4_1') }}</div>
                        <div class="paragraph">{{ $t('policy7Message5_1') }}</div>
                    </div>
                </div>

                <div>
                    <h2 class="title-3">{{ $t('policy8') }}</h2>
                    <div>
                        <div>
                            <div class="paragraph">{{ $t('policy8Message0_1') }}</div>
                            <div>
                                <div class="paragraph">{{ $t('policy8Message1_1') }}</div>
                                <div class="paragraph-indent">
                                    <div class="paragraph">{{ $t('policy8Message1_1_1') }}</div>
                                    <div class="paragraph">{{ $t('policy8Message1_1_2') }}</div>
                                    <div class="paragraph">{{ $t('policy8Message1_1_3') }}</div>
                                    <div class="paragraph">{{ $t('policy8Message1_1_4') }}</div>
                                    <div class="paragraph">{{ $t('policy8Message1_1_5') }}</div>
                                </div>
                            </div>
                            <div>
                                <div class="paragraph">{{ $t('policy8Message2_0') }}</div>
                                <div class="paragraph-indent">
                                    <div>
                                        <div class="paragraph">{{ $t('policy8Message2_1_1') }}</div>
                                        <div class="paragraph">{{ $t('policy8Message2_1_2') }}</div>
                                        <div class="paragraph">{{ $t('policy8Message2_1_3') }}</div>
                                        <div class="paragraph">{{ $t('policy8Message2_1_4') }}</div>
                                        <div class="paragraph">
                                            <span>{{ $t('privacyLink') }}:</span>
                                            <a :href="$t('policy8Message2_1_5')">
                                                {{ $t('clickToView') }}
                                            </a>
                                        </div>
                                    </div>

                                    <div>
                                        <div class="paragraph">{{ $t('policy8Message2_2_1') }}</div>
                                        <div class="paragraph">{{ $t('policy8Message2_2_2') }}</div>
                                        <div class="paragraph">{{ $t('policy8Message2_2_3') }}</div>
                                        <div class="paragraph">{{ $t('policy8Message2_2_4') }}</div>
                                        <div class="paragraph">
                                            <span>{{ $t('privacyLink') }}:</span>
                                            <a :href="$t('policy8Message2_2_5')">
                                                {{ $t('clickToView') }}
                                            </a>
                                        </div>
                                    </div>

                                    <div>
                                        <div class="paragraph">{{ $t('policy8Message2_3_1') }}</div>
                                        <div class="paragraph">{{ $t('policy8Message2_3_2') }}</div>
                                        <div class="paragraph">{{ $t('policy8Message2_3_3') }}</div>
                                        <div class="paragraph">{{ $t('policy8Message2_3_4') }}</div>
                                        <div class="paragraph">
                                            <span>{{ $t('privacyLink') }}:</span>
                                            <a :href="$t('policy8Message2_3_5')">
                                                {{ $t('clickToView') }}
                                            </a>
                                        </div>
                                    </div>

                                    <div>
                                        <div class="paragraph">{{ $t('policy8Message2_4_1') }}</div>
                                        <div class="paragraph">{{ $t('policy8Message2_4_2') }}</div>
                                        <div class="paragraph">{{ $t('policy8Message2_4_3') }}</div>
                                        <div class="paragraph">{{ $t('policy8Message2_4_4') }}</div>
                                        <div class="paragraph">
                                            <span>{{ $t('privacyLink') }}:</span>
                                            <a :href="$t('policy8Message2_4_5')">
                                                {{ $t('clickToView') }}
                                            </a>
                                        </div>
                                    </div>

                                    <div>
                                        <div class="paragraph">{{ $t('policy8Message2_5_1') }}</div>
                                        <div class="paragraph">{{ $t('policy8Message2_5_2') }}</div>
                                        <div class="paragraph">{{ $t('policy8Message2_5_3') }}</div>
                                        <div class="paragraph">{{ $t('policy8Message2_5_4') }}</div>
                                        <div class="paragraph">
                                            <span>{{ $t('privacyLink') }}:</span>
                                            <a :href="$t('policy8Message2_5_5')">
                                                {{ $t('clickToView') }}
                                            </a>
                                        </div>
                                    </div>

                                    <div>
                                        <div class="paragraph">{{ $t('policy8Message2_6_1') }}</div>
                                        <div class="paragraph">{{ $t('policy8Message2_6_2') }}</div>
                                        <div class="paragraph">{{ $t('policy8Message2_6_3') }}</div>
                                        <div class="paragraph">{{ $t('policy8Message2_6_4') }}</div>
                                        <div class="paragraph">
                                            <span>{{ $t('privacyLink') }}:</span>
                                            <a :href="$t('policy8Message2_6_5')">
                                                {{ $t('clickToView') }}
                                            </a>
                                        </div>
                                    </div>

                                    <div>
                                        <div class="paragraph">{{ $t('policy8Message2_7_1') }}</div>
                                        <div class="paragraph">{{ $t('policy8Message2_7_2') }}</div>
                                        <div class="paragraph">{{ $t('policy8Message2_7_3') }}</div>
                                        <div class="paragraph">{{ $t('policy8Message2_7_4') }}</div>
                                        <div class="paragraph">
                                            <span>{{ $t('privacyLink') }}:</span>
                                            <a :href="$t('policy8Message2_7_5')">
                                                {{ $t('clickToView') }}
                                            </a>
                                        </div>
                                    </div>

                                    <div>
                                        <div class="paragraph">{{ $t('policy8Message2_8_1') }}</div>
                                        <div class="paragraph">{{ $t('policy8Message2_8_2') }}</div>
                                        <div class="paragraph">{{ $t('policy8Message2_8_3') }}</div>
                                        <div class="paragraph">{{ $t('policy8Message2_8_4') }}</div>
                                        <div class="paragraph">
                                            <span>{{ $t('privacyLink') }}:</span>
                                            <a :href="$t('policy8Message2_8_5')">
                                                {{ $t('clickToView') }}
                                            </a>
                                        </div>
                                    </div>

                                    <div>
                                        <div class="paragraph">{{ $t('policy8Message2_9_1') }}</div>
                                        <div class="paragraph">{{ $t('policy8Message2_9_2') }}</div>
                                        <div class="paragraph">{{ $t('policy8Message2_9_3') }}</div>
                                        <div class="paragraph">{{ $t('policy8Message2_9_4') }}</div>
                                        <div class="paragraph">
                                            <span>{{ $t('privacyLink') }}:</span>
                                            <span>
                                                {{ $t('policy8Message2_9_5') }}
                                            </span>
                                        </div>
                                    </div>

                                    <div v-if="showLang === Lang.zhCN">
                                        <div class="paragraph">
                                            {{ $t('policy8Message2_10_1') }}
                                        </div>
                                        <div class="paragraph">
                                            {{ $t('policy8Message2_10_2') }}
                                        </div>
                                        <div class="paragraph" v-html="$t('policy8Message2_10_3')">
                                            <!--                                            {{ $t('policy8Message2_10_3') }}-->
                                        </div>
                                        <div class="paragraph">
                                            {{ $t('policy8Message2_10_4') }}
                                        </div>
                                        <div class="paragraph">
                                            <span>{{ $t('privacyLink') }}:</span>
                                            <a :href="$t('policy8Message2_10_5')">
                                                {{ $t('clickToView') }}
                                            </a>
                                        </div>
                                    </div>
                                    <div v-if="showLang === Lang.zhCN">
                                        <div class="paragraph">
                                            （11）腾讯移动分析 （com.tencent.stat）SDK
                                        </div>
                                        <div class="paragraph">
                                            第三方公司名称：深圳市腾讯计算机系统有限公司
                                        </div>
                                        <div class="paragraph">
                                            使用场景：用户使用微信和qq的快速登录、分享功能时
                                            涉及到个人信息：设备信息，IMEI、MAC地址、运营商、传感器列表、ssid/bssid
                                            、IP地址；
                                        </div>
                                        <div class="paragraph">共享方式：SDK本机采集</div>
                                        <div class="paragraph">
                                            获取的敏感权限：读取手机身份和状态、存储
                                        </div>
                                        <div class="paragraph">
                                            <span>{{ $t('privacyLink') }}:</span>
                                            <a
                                                href="https://cloud.tencent.com/document/product/301/11470"
                                            >
                                                {{ $t('clickToView') }}
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div>
                    <h2 class="title-3">{{ $t('policy9') }}</h2>
                    <div>
                        <div class="paragraph">{{ $t('policy9Message0_1') }}</div>
                    </div>
                </div>

                <div>
                    <h2 class="title-3">{{ $t('policy10') }}</h2>
                    <div>
                        <div class="paragraph">{{ $t('policy10Message1') }}</div>
                        <div class="paragraph">{{ $t('policy10Message2') }}</div>
                    </div>
                </div>

                <div>
                    <h2 class="title-3">{{ $t('policy11') }}</h2>
                    <div>
                        <div v-if="showLang === Lang.enUS" class="paragraph">
                            {{ $t('policy11Message0_1') }}
                        </div>
                        <div v-else>
                            <div class="paragraph">
                                {{ $t('policy11Message1') }}
                            </div>
                            <div class="paragraph-indent">
                                <div class="paragraph">{{ $t('policy11Message1_1') }}</div>
                                <div class="paragraph">{{ $t('policy11Message1_2') }}</div>
                                <div class="paragraph">{{ $t('policy11Message1_3') }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="takee-effect-c">
            <div class="paragraph">{{ $t('takeeEffect1') }}</div>
            <div class="paragraph">{{ $t('takeeEffect2') }}</div>
            <div class="paragraph">{{ $t('takeeEffect3') }}</div>
            <div class="paragraph">{{ $t('takeeEffect4') }}</div>
        </div>
    </div>
</template>

<script>
    import { RouterNames } from '@/router';
    import { Lang } from '@/store/types';
    export default {
        name: 'agreementHome',
        computed: {
            RouterNames() {
                return RouterNames;
            },
            showLang() {
                return this.$store.getters.showLang;
            },
            Lang() {
                return Lang;
            },
        },
    };
</script>

<style scoped lang="less">
    .takee-effect-c {
        margin-top: 50px;
    }
</style>
